import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import { ToggleSwitch, Input } from "@abb/abb-common-ux-react";
import { SampleSettings } from "../../models/settings/SampleSettings";
import ISampleSettings from "../../models/settings/SampleSettings";

interface IProps {
  settings: SampleSettings[];
  setName: (id: string, value: string) => void;
  onToggle: (id: string, value: any) => void;
}
export default class SampleSettingLanding extends React.Component<IProps> {
  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout h-100">
            <div className="summary-layout mt-4">
              <div className="col-12">
                <div className="row">
                  <label className="col-2">{t("Field key")}</label>
                  <label className="col-7">{t("Field text value")}</label>
                  <label className="col-2">{t("Show field")}</label>
                </div>
                {this.props.settings?.map(
                  (data: ISampleSettings, index: number) => {
                    return (
                      <div className="row mt-2" key={index}>
                        <label className="col-2">{t(data.key)}</label>
                        <Input
                          className="col-7"
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          value={t(data.name)}
                          onValueChange={(v) => this.props.setName(data.id, v)}
                          maxLength={250}
                        />
                        <ToggleSwitch
                          monochrome={true}
                          showIcons={true}
                          value={data.show}
                          onChange={(v) => this.props.onToggle(data.id, v)}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
